angular.module('mercury.modules.time.clock')
.factory('TimeConstants', function() {
  return {
    ShiftType: {
      Clockin: 'Clockin',
      Roster: 'Roster'
    }
  };
});
